import { DataIsNotAvailableError, ForbiddenPageError } from 'components/renderError'

interface Props {
  isForbidden: boolean
}

export const OsStateError = ({ isForbidden }: Props) => {
  return isForbidden ? <ForbiddenPageError /> : <DataIsNotAvailableError />
}
